/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/

export default {
    send_message: 'Send Message',
    submit      : 'Submit',
    cancel      : 'Cancel',
    learn_more  : 'Learn more',
    load_more   : 'Load more',
    alt         : {
        play: 'Play',
    },
};
